import * as React from "react";
import type { SVGProps } from "react";
const SvgEurowings = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 50 50"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fill="#7bcbe2"
      d="M18.444 11.084c-4.007-.548-6.042 1.682-8.848 3.733L.003 22.35 0 22.35l1.847.977q.005.004.012.007c2.403 1.181 5.744.778 8.02-.908l4.05-3.218 1.549-1.233 7.72-6.133z"
    />
    <path
      fill="#089bc9"
      d="m.003 22.35 1.844.98q.006.002.012.005c2.403 1.183 5.746.78 8.02-.908l4.05-3.217 1.55-1.232z"
    />
    <path
      fill="#8f174f"
      d="m34.825 15.737-5.15-.927s-3.585-.852-6.58 1.469c0 0-2.212 1.645-3.843 2.917l-3.627 2.873-8.39 6.674-.07.055 2.533 1.34c2.404 1.187 5.753.785 8.032-.903l7.502-5.943 6.05-4.765z"
    />
    <g fill="#c8c4c3">
      <path d="M19.254 19.196c1.628-1.272 3.84-2.917 3.84-2.917a7.5 7.5 0 0 1 1.734-1.003l-9.347 2.702-1.55 1.23-4.048 3.22c-2.275 1.687-5.618 2.09-8.02.907 2.048 1.228 5.23 1.51 10.022.081l3.273-.974.47-.373zM32.44 22.058c1.544-1.209 2.709-2.084 3.868-2.604l-10.463 3.355-.615.484-7.502 5.942c-2.278 1.688-5.627 2.092-8.031.903 3.693 2.028 9.381.537 14.165-1.164l.285-.231s8.007-6.478 8.292-6.685M44.743 28.798c-4.2-1.22-5.46-.448-10.407 1.04h-.002l-.413.343v-.001l-.004.004.004-.003-.012.008-7.974 6.323c-2.272 1.684-5.823 2.008-8.225.831 2.964 1.546 6.029 1.168 11.273-.468L50 30.423z" />
    </g>
    <path
      fill="#8f174f"
      d="m46.137 20.08-5.56-1.012c-3.33-.618-4.905.459-8.14 2.99-.285.208-8.292 6.685-8.292 6.685l-8.989 7.252 2.532 1.34c2.405 1.188 5.972.865 8.248-.823l7.974-6.323.011-.008-.004.003z"
    />
    <path
      fill="#b4175e"
      d="m15.156 22.442 17.778-5.218-7.09 5.585-18.68 5.99zM23.86 28.972l19.36-6.48-8.884 7.346-19.178 6.157z"
    />
  </svg>
);
export default SvgEurowings;
